import store from '@/store/store'
import router from '@/router'
import config from '@/config'

export const isBranded = (query) => {
	const { branded } = query ? query : router.app.$route.query

	return config.DOMAIN ? store.getters['tours/getBranded'] : branded === '1'
}
